export const L10N = {
  LABEL_360_VIEW: { id: 'core.label.360_view' },
  LABEL_VIEW_VIDEO: { id: 'core.label.view_video' },
};
